export default __webpack_public_path__ + "static/media/services-bg.12f5bdb0.webp";